import { useCallback } from 'react';
import { useIsomorphicLayoutEffect } from '@direct-frontend/stdlib';

// Хук для программной установки position: relative на элемент с position: static
export const useRelativePositionForStaticTarget = (targetElement: HTMLElement | null) => {
    const setRelativePosition = useCallback(() => {
        if (!targetElement || typeof window === 'undefined') {
            return undefined;
        }

        const targetPosition = window.getComputedStyle(targetElement).position;

        if (targetPosition !== 'static') {
            return undefined;
        }

        const previousPosition = targetElement.style.position;
        // eslint-disable-next-line react-hooks/immutability -- безопасно устанавливаем только для static
        targetElement.style.position = 'relative';

        return () => {
            targetElement.style.position = previousPosition;
        };
    }, [targetElement]);

    useIsomorphicLayoutEffect(setRelativePosition);
};
